export default {
    key: "cp_rsr_request",
    id: "rsr_req_id",
    type: "readonly",
    export: ["excel"],
    excel: {
        //max_row:"50000"
    },
    sort: {
        field: "rsr_req_id",
        order: "desc"
    },
    sort_fields: [
        "rsr_req_id",
        "cre_dttm",
        "cp_no"
    ],
    filters:{
        cp_no:{},
        cre_dttm: {
            type: "daterange"
        }
    },
    action: ["view"],
    view: [
        ["cp_no"],
        ["request_data"],
        ["response_data"],

    ],
    fields:[
        { key: "id", field:"rsr_req_id", width:50},
        { key: "cp_no", width:80},
        { key: "cre_dttm", type: "datetime", width:120},
        { key: "request_data"},
        { key: "response_data"},
        {key: "action_button", type: "action-btn", width: "45px"},
    ]
}